import {DynamicForm} from 'vetrina-ui';
import {toast} from 'react-toastify';
import {createHomePageBlock, updateHomePageBlock} from 'src/utils/AdminApi';
import {handleRequestError} from 'src/utils/helperMethods';
import {getRequiredStringValidation} from 'src/schema/commanValidationSchema';
import useCategories from 'src/hooks/useCategories';
import {FileUploadField} from 'src/components/inputs/ImageCropPicker.js/FileUploadField';
import {BLOCK_TYPES} from './blockTypes';

const ALIGN_OPTIONS = [
	{id: 'start', label: 'بداية'},
	{id: 'center', label: 'وسط'},
	{id: 'end', label: 'نهاية'},
];

const SIZE_OPTIONS = [
	{id: 'sm', label: 'صغير'},
	{id: 'base', label: 'عادي'},
	{id: 'lg', label: 'كبير'},
	{id: 'xl', label: 'كبير جداً'},
];

function getInputsForType(type, categories) {
	if (type === BLOCK_TYPES.TEXT) {
		return [
			{
				name: 'text',
				type: 'text',
				label: 'النص',
				multiline: true,
				rows: 4,
				validation: getRequiredStringValidation('يرجي ادخال النص'),
			},
			{
				name: 'align',
				type: 'picker',
				label: 'المحاذاة',
				options: ALIGN_OPTIONS,
				labelKey: 'label',
				valueKey: 'id',
			},
			{
				name: 'size',
				type: 'picker',
				label: 'الحجم',
				options: SIZE_OPTIONS,
				labelKey: 'label',
				valueKey: 'id',
			},
		];
	}

	if (type === BLOCK_TYPES.IMAGE) {
		return [
			{
				name: 'src',
				label: 'الصورة',
				component: ({formik, input}) => (
					<FileUploadField
						value={formik.values[input.name]}
						defaultImage={formik.values[input.name]}
						label="الصورة"
						ratio={null}
						onChange={(id, file) => formik.setFieldValue(input.name, file?.url ?? '')}
					/>
				),
			},
			{name: 'alt', type: 'text', label: 'نص بديل (alt)'},
			{name: 'href', type: 'text', label: 'رابط عند الضغط (اختياري)', placeholder: '/category/1'},
		];
	}

	if (type === BLOCK_TYPES.CATEGORY_PRODUCTS) {
		return [
			{
				name: 'categoryId',
				type: 'picker',
				label: 'التصنيف',
				options: categories,
				labelKey: 'name',
				valueKey: 'id',
				validation: getRequiredStringValidation('يرجي اختيار تصنيف'),
			},
			{name: 'title', type: 'text', label: 'عنوان مخصص (اختياري)'},
		];
	}

	// ALL_CATEGORIES_PRODUCTS has no configurable fields
	return [];
}

// Create/edit form for a single home page block. `type` is fixed once a block is created.
export default function BlockForm({type, initialData, onSuccess}) {
	const isEdit = Boolean(initialData?.id);
	const {categories} = useCategories();

	return (
		<DynamicForm
			submitButtonText={isEdit ? 'تعديل' : 'اضافة'}
			initialValues={initialData?.data}
			config={{inputs: getInputsForType(type, categories)}}
			onSubmit={async (formData) => {
				try {
					if (isEdit) {
						await updateHomePageBlock(initialData.id, formData);
						onSuccess({...initialData, data: formData});
					} else {
						const created = await createHomePageBlock(type, formData);
						onSuccess({id: created?.id, type, data: formData});
					}
					toast.success(isEdit ? 'تم التعديل بنجاح' : 'تم الاضافة بنجاح');
				} catch (err) {
					toast.error(handleRequestError(err));
				}
			}}
		/>
	);
}
